module.exports = __webpack_public_path__ + "img/heart_19.72229ae7.png";